import { UserRoleToAssign } from "Types/user.types";
import { useSession } from ".";
import { useMemo } from "react";

export const useCheckUserRole = () => {
  const { roles } = useSession();

  const isRole = useMemo(
    () => (requiredRoles: UserRoleToAssign[]) => {
      if (!roles || roles.length === 0) return false;
      return requiredRoles.includes(roles[0].subType as UserRoleToAssign);
    },
    [roles[0]?.subType],
  );

  return { isRole };
};

export default useCheckUserRole;
